import * as Yup from 'yup';

Yup.addMethod(Yup.string, 'mobile', function (messageError = 'Mobile number is not valid') {
    const phoneRegExp = /^09[0-9]{9}$/;
    return this.test('mobile', messageError, (value) => {
        if (value && value.length > 0) {
            return phoneRegExp.test(value);
        }
        return true;
    });
});

Yup.addMethod(Yup.string, 'name', function (messageError = 'Min: 3, Max: 255') {
    const nameRegExp = /^[?]{3,255}$/;
    return this.test('name', messageError, (value) => {
        if (value && value.length > 0) {
            return nameRegExp.test(value);
        }
        return true;
    });
});

Yup.addMethod(Yup.string, 'isDigits', function (messageError = 'Invalid Number') {
    return this.test('isDigits', messageError, (value) => {
        if (value && value.length > 0) {
            return parseFloat(value.replace(/\,/g, '')) > 0;
        }
        return true;
    });
});

Yup.addMethod(Yup.string, 'moreThan', function (num, message) {
    return this.test('moreThan', message, (value) => {
        if (value && value.length > 0) {
            if (parseFloat(value.replace(/\,/g, '')) < num) return false;
        }
        return true;
    });
});

Yup.addMethod(Yup.string, 'lessThan', function (num, message) {
    return this.test('lessThan', message, (value) => {
        if (value && value.length > 0) {
            if (parseFloat(value.replace(/\,/g, '')) > num) return false;
        }
        return true;
    });
});
